/** @format */
import { Market } from '@toucan/client/global/market';

import { fetchSearchResultsInBatches } from '../batches';
import { getSearchResults } from '../requests';
import { Query, QueryResponse, SearchListingProduct } from '../types';
import { PRODUCT_FACET_FIELDS } from './constants';
import { getProductListingSortBy, getProductResultsRows } from './helpers';
import {
    getProductListingFacetsQuery,
    getProductSearchResultsQuery,
} from './queries';
import { ProductSearchParams } from './types';

type ModifierGroups = Parameters<typeof getProductSearchResultsQuery>[6];

export function fetchProductSearchResults(
    baseQuery: Partial<Query>,
    { pageIndex, filterQuery, sort }: ProductSearchParams,
    resultsPerPage: number,
    market: Market,
    modifierGroups?: ModifierGroups
): Promise<QueryResponse<SearchListingProduct>> {
    const sortBy = getProductListingSortBy(sort);
    const rows = getProductResultsRows(pageIndex, resultsPerPage);

    return fetchSearchResultsInBatches(0, rows, (batchStart, batchRows) =>
        getSearchResults<SearchListingProduct>(
            getProductSearchResultsQuery(
                baseQuery,
                batchStart,
                batchRows,
                filterQuery,
                sortBy,
                market.code,
                modifierGroups
            ),
            market.iso,
            market.code
        )
    );
}

export function fetchProductFacets(
    baseQuery: Partial<Query>,
    market: Market
): Promise<QueryResponse<SearchListingProduct>> {
    return getSearchResults<SearchListingProduct>(
        getProductListingFacetsQuery(
            baseQuery,
            market.code,
            PRODUCT_FACET_FIELDS
        ),
        market.iso,
        market.code
    );
}
